<div class="loading-full-colibri boardingPassPaperEmpty-root">
  <app-navbar
    [showStartOver]="false"
    [status]="96"
    [showShortIcon]="true"
    [showSkyPriority]="false"
    [showLanguagesButton]="false"
  ></app-navbar>
  <div class="content bg-am-premium-blue boardingPassPaperEmpty-content">
    <div class="boardingPassPaperEmpty-panel">
      <h1 class="boardingPassPaperEmpty-title">{{ titleKey | translate }}</h1>
      <p class="boardingPassPaperEmpty-message">{{ messageKey | translate }}</p>
      <p class="boardingPassPaperEmpty-instructions">{{ instructionsKey | translate }}</p>
    </div>
  </div>
</div>
